//libs
import { ClassState, useClassState } from "libs/useClassState";

type PathGenerator = (page: number) => string;

export class PaginationState extends ClassState {
  private pathGenerator: PathGenerator;
  private page: number;
  private total: number;
  private itemsPerPage: number;
  constructor(pathGenerator: PathGenerator, page: number, total: number, itemsPerPage: number) {
    super();
    this.pathGenerator = pathGenerator;
    this.page = page;
    this.total = total;
    this.itemsPerPage = itemsPerPage;
  }

  getPage() {
    return this.page;
  }

  active(page: number) {
    return this.page === page;
  }

  disabled(item: number) {
    return this.page === item;
  }

  getTotal() {
    return this.total;
  }

  getPageCount() {
    return Math.max(Math.ceil(this.total / this.itemsPerPage), 1);
  }

  generatePath(page: number) {
    return this.pathGenerator(page);
  }
}

function usePaginationHandler(...args: ConstructorParameters<typeof PaginationState>) {
  const state = useClassState(PaginationState, args);
  return state;
}

export default usePaginationHandler;
